import React from 'react';
import {SyntheticEvent} from 'react';

import {AddToCartButtonSkeleton} from './AddToCartButtonSkeleton';
import {AddToCartButtonStyled, AlternateAddToCartButtonStyled} from './styles';

export type AddToCartButtonProps = {
  onAdd: (e: SyntheticEvent) => void;
  disabled: boolean;
  title: string;
  loading: boolean;
  disableRipple: boolean;
  isInstallmentType?: boolean;
};

export const AddToCartButton: React.FC<AddToCartButtonProps> = ({
  onAdd,
  title,
  disabled,
  loading,
  disableRipple,
  isInstallmentType
}) => {
  const isInstallmentEnabledAndType = isInstallmentType;

  if (loading) {
    return <AddToCartButtonSkeleton isInstallmentEnabledAndType={isInstallmentEnabledAndType} />;
  }

  return isInstallmentEnabledAndType ? (
    <AlternateAddToCartButtonStyled
      className={'leo'}
      loading={loading}
      fullWidth
      variant="outlined"
      shape="rounded"
      onClick={onAdd}
      disabled={disabled}
      disableRipple={disableRipple}
      isInstallmentType={isInstallmentEnabledAndType}
    >
      {title}
    </AlternateAddToCartButtonStyled>
  ) : (
    <AddToCartButtonStyled
      className={'leo'}
      loading={loading}
      fullWidth
      variant="contained"
      shape="rounded"
      onClick={onAdd}
      disabled={disabled}
      disableRipple={disableRipple}
    >
      {title}
    </AddToCartButtonStyled>
  );
};
